import {debounce} from "../../../lib";
import ReviewsSlider from "../../../components/reviews-slider";
import Accordion from "../../../components/accordion";

export default class PageModule {
    constructor() {
        this.initServicesSection();
        this.initFeedback();
        this.initFaqSection();
    }

    initServicesSection() {
        this.setServiceCardIconScaleFactor();

        window.addEventListener('resize', debounce(this.setServiceCardIconScaleFactor.bind(this), 25));
    }

    setServiceCardIconScaleFactor() {
        const $cards = document.querySelectorAll('.hero-service');
        const mediaMatches = window.matchMedia('(max-width: 1024px)').matches;

        $cards.forEach(($card) => {
            const width = $card.getBoundingClientRect().width;
            const scaleFactor = width * 9.5;
            $card.style = `--icon-scale-factor: ${Math.round(mediaMatches ? 4000 : scaleFactor)}%;`;
        });
    }

    initFeedback() {
        new ReviewsSlider();
    }

    initFaqSection() {
        new Accordion('accordion-faq');
    }
}